import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-826d8f34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-tenant-wrapper" }
const _hoisted_2 = { class: "el-dropdown-link" }

import { ref, computed } from 'vue'
import { queryTenantTreeList } from '@/api'
import { CODE_ENUM, TENANT_TYPE } from '@/common'
import { useTenantStore } from '@/stores/tenant'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: ['modelValue', 'showType'],
  emits: ['update:modelValue','change'],
  setup(__props, { emit: __emit }) {

const type = ref(TENANT_TYPE.COMPANY)

const typeText = {
  [TENANT_TYPE.COMPANY]: '企业',
  [TENANT_TYPE.PERSON]: '个人',
}

const currentType = computed(() => {
  return typeText[type.value]
})

const handleCommand = (value: any) => {
  if (type.value === value) {
    return
  }
  type.value = value
  $emit('update:modelValue', '')
  queryTenant()
}

const tenantStore = useTenantStore()

const props: any = __props
const $emit = __emit

const change = (value: any) => {
  $emit('update:modelValue', value)
  $emit('change', value)

}

const options: any = ref([])
const loading = ref(false)

const queryTenant = async () => {
  loading.value = true
  const res: any = await queryTenantTreeList({
    userType: Number(type.value !== TENANT_TYPE.COMPANY),
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    options.value = (res.data || []).map(({ orgName, orgId }: any) => {
      return {
        label: orgName,
        value: orgId,
      }
    })
  }
}

queryTenant()

return (_ctx: any,_cache: any) => {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.showType)
      ? (_openBlock(), _createBlock(_component_el_dropdown, {
          key: 0,
          onCommand: handleCommand,
          class: "drop-type"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  command: _unref(TENANT_TYPE).COMPANY
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("企业")
                  ]),
                  _: 1
                }, 8, ["command"]),
                _createVNode(_component_el_dropdown_item, {
                  command: _unref(TENANT_TYPE).PERSON
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("个人")
                  ]),
                  _: 1
                }, 8, ["command"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _createTextVNode(_toDisplayString(currentType.value) + " ", 1),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_arrow_down)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_select_v2, {
      filterable: "",
      options: options.value,
      loading: loading.value,
      class: "ws_select",
      clearable: "",
      onChange: change,
      modelValue: props.modelValue
    }, null, 8, ["options", "loading", "modelValue"])
  ]))
}
}

})